var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('div',{staticClass:"sidebar__wrapper"},[_c('div',{staticClass:"sidebar__first"},[_c('label',{staticClass:"sidebar__label"},[_vm._v("Formlar")]),_c('router-link',{attrs:{"to":{name: 'formlist'}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('a',{staticClass:"sidebar__item",class:{'-active': isActive},attrs:{"href":href},on:{"click":navigate}},[_vm._v("Form Listesi")])]}}])}),_c('router-link',{attrs:{"to":{name: 'newform'}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('a',{staticClass:"sidebar__item",class:{'-active': isActive},attrs:{"href":href},on:{"click":navigate}},[_vm._v("Yeni Form")])]}}])})],1),_c('div',{staticClass:"sidebar__last"},[_c('label',{staticClass:"sidebar__label"},[_vm._v("Markalar")]),_c('router-link',{attrs:{"to":{name: 'companylist'}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('a',{staticClass:"sidebar__item",class:{'-active': isActive},attrs:{"href":href},on:{"click":navigate}},[_vm._v("Marka Listesi")])]}}])}),_c('router-link',{attrs:{"to":{name: 'newcompany'}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var href = ref.href;
var route = ref.route;
var navigate = ref.navigate;
var isActive = ref.isActive;
return [_c('a',{staticClass:"sidebar__item",class:{'-active': isActive},attrs:{"href":href},on:{"click":navigate}},[_vm._v("Yeni Marka")])]}}])})],1)]),_c('p',{staticClass:"sidebar__copyright"},[_vm._v("© 2020 Gricreative. Tüm Hakları Saklıdır.")])])}
var staticRenderFns = []

export { render, staticRenderFns }